import React, { createContext, useContext, useRef, useState } from 'react'

const FiltersContext = createContext()

const useFilters = () => {
  return useContext(FiltersContext)
}

export const FiltersProvider = ({ filterValues, children }) => {
  const selectedFiltersRef = useRef([])
  const [columnFilters, setColumnFilters] = useState([
    {
      id: 'status',
      value: filterValues,
    },
  ])
  const clearFilters = () => {
    setColumnFilters([
      {
        id: 'status',
        value: filterValues,
      },
    ])
    selectedFiltersRef.current = []
  }

  const selectedFilters = selectedFiltersRef.current
  const isActive = (filterValue) =>
    selectedFiltersRef.current.includes(filterValue)
  const addFilter = (filterValue) => {
    if (!selectedFilters.includes(filterValue)) {
      setColumnFilters((prev) => {
        console.log('prev', prev)
        const existingFilter = prev.find((filter) => filter.id === 'status')
        if (selectedFilters.length > 0) {
          const newFilters = [...existingFilter.value, filterValue]
          selectedFiltersRef.current = newFilters
          return [{ id: 'status', value: newFilters }]
        } else {
          const newFilters = [filterValue]
          selectedFiltersRef.current = newFilters
          return [{ id: 'status', value: newFilters }]
        }
      })
    }
  }
  const removeFilter = (filterValue) => {
    setColumnFilters((prev) => {
      const existingFilter = prev.find((filter) => filter.id === 'status')
      const newFilters = existingFilter.value.filter((f) => f !== filterValue)
      selectedFiltersRef.current = newFilters

      return [
        {
          id: 'status',
          value: newFilters.length > 0 ? newFilters : filterValues,
        },
      ]
    })
  }

  const handleFilterClick = (filterValue) => {
    if (isActive(filterValue)) {
      removeFilter(filterValue)
    } else addFilter(filterValue)
  }

  const value = {
    filterValues,
    clearFilters,
    handleFilterClick,
    columnFilters,
    isActive,
  }
  return (
    <FiltersContext.Provider value={value}>{children}</FiltersContext.Provider>
  )
}

export default useFilters
